export class Permissions {
  constructor(user = null) { this.update(user); }
  update(user) { this.user = user || null; this.role = String(user?.role || '').toLowerCase(); this.matrix = user?.permissions && typeof user.permissions === 'object' ? user.permissions : {}; }
  can(section, action = 'view') { return Boolean(this.matrix?.[String(section)]?.[String(action)]); }
  any(rules = []) { return rules.some(([section, action]) => this.can(section, action)); }
  hasAnyAccess() { return Object.values(this.matrix).some(actions => actions && Object.values(actions).some(Boolean)); }
}
